<script>
/*

Author Rômulo Rocha <romulo.ufg@gmail.com>

*/
export default {
    props: {
        data: Array,
        column: Array,
        tableAttr: Array,
        actions: Array,
        openedFilter: {
            default: false
        }
    },
    data() {

        return {
            showFilter: false,
            showColumn: {},
            indexToFilter: this.column[0][1],
            search: {},
            sortOrder: 0,
            currentPage: 1,
            perPage: 30,
            actualPage: 1,
            totalRegistros: 0,
            totalDisplay: 6,
            selectedItens: []
        }
    },
    methods: {
        initShowColumn: function () {
            let initColumn = {};
            for (var col of this.column) {
                initColumn[col[1]] = true;
            }

            return initColumn;
        },
        initSearch: function () {
            let initSearch = {};
            for (var col of this.column) {
                initSearch[col[1]] = "";
            }

            return initSearch;
        },
        findBy: function () {
            return this.data.filter(item => {
                if (!isNaN(parseFloat(item[this.indexToFilter]))) {
                    return item[this.indexToFilter].toString().indexOf(this.search[this.indexToFilter].toString()) > -1;
                } else {
                    return item[this.indexToFilter].toLowerCase().indexOf(this.search[this.indexToFilter].toLowerCase()) > -1;
                }

            })
        },
        orderBy: function (list, order, column) {
            return list.sort(function (a, b) {
                return order * (a[column] - b[column])
            })
        },
        filtrar: function (index) {
            this.actualPage = 1;
            this.indexToFilter = index;
        },
        classSort: function (key) {
            if (key === this.indexToFilter && this.sortOrder != 0) {

                return (this.sortOrder == 1) ? {
                    'column-order-az': true
                } : {
                    'column-order-za': true
                };
            }
            return {
                'column-order': true
            };
        },
        sorter: function (coluna) {

            this.indexToFilter = coluna;
            this.sortOrder = (this.sortOrder == 0) ? 1 : this.sortOrder * -1;
        },
        clearSearch: function (coluna) {
            this.search[coluna] = "";
        },
        exp: function (id) {
            this.$emit('exp', id)
        },
        show: function (id) {
            this.$emit('show', id);
        },
        edit: function (id) {
            this.$emit('edit', id);
        },
        delet: function (id) {
            this.$emit('delet', id);
        },
        recover: function (id) {
            this.$emit('recover', id);
        },
        openImg: function (url, nome) {
            //this.$emit('ShowImage',url);
            this.$swal.fire({
                imageUrl: url,
                text: nome,
                showCloseButton: true,
                animation: false
            });
        },
        markAll: function (event) {
            let checked = event.target.checked;
            this.selectedItens = [];
            if (checked) {
                var vm = this;
                this.data.forEach(function (item) {
                    if (item.selectable) {
                        vm.selectedItens.push(item.id);
                    }
                });

            }

            this.$emit('markAll', event.target.checked);
        },
        changeSelect: function (event) {
            let valor = parseInt(event.target.value);
            let checked = event.target.checked;
            this.$emit('change', checked, valor);
        }

    },
    computed: {
        filteredData() {

            if (this.sortOrder == 0) {
                var data = this.findBy();

            } else {
                var data = _.orderBy(this.findBy(), this.indexToFilter, this.orderToSort);
            }

            this.totalRegistros = data.length;

            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return data.slice(start, end);

            // return data.slice(this.start, this.end);
        },
        orderToSort() {

            return (this.sortOrder == 1) ? 'asc' : 'desc';

        },
        totalPaginas() {
            return Math.ceil(this.totalRegistros / this.qtdPerPage);
        },
        start() {

            return (this.actualPage - 1) * this.qtdPerPage;
        },
        end() {
            return this.actualPage * this.qtdPerPage;
        },
        displayStart() {
            var qtdInicio = Math.floor(this.totalDisplay / 2);

            if ((this.totalPaginas - this.actualPage) < qtdInicio) {
                return this.actualPage - (qtdInicio - (this.totalPaginas - this.actualPage - qtdInicio));
            } else {
                return this.actualPage - qtdInicio;
            }

        },
        displayEnd() {
            var qtdInicio = Math.floor(this.totalDisplay / 2);

            if (this.totalPaginas >= this.actualPage + qtdInicio) {
                return this.actualPage + qtdInicio;
            } else if (this.actualPage - qtdInicio <= 0) {
                return this.actualPage + qtdInicio + (this.actualPage - qtdInicio) * -1 + 1;
            } else {
                return this.totalPaginas;
            }

        },
        qtdPerPage() {
            let qtd = parseInt(this.perPage);
            if (qtd > 1) {
                return qtd;
            }

            return 1;
        }

    },
    beforeMount: function () {

        this.showColumn = this.initShowColumn();
        this.search = this.initSearch();
    },
    mounted: function () {
        this.showFilter = this.openedFilter;
    }

}
</script>

<template>
<div class="row">

    <div class="col-md-12 mb-2 text-right no-print">

        <div class="btn-group" role="group" aria-label="Button group with nested dropdown">

            <button class="btn btn-secondary" @click="showFilter = !showFilter">
                <i class="fa fa-eye" v-if="!showFilter"></i>
                <i class="fa fa-eye-slash" v-if="showFilter"></i>
            </button>

            <div class="btn-group" role="group">
                <button id="btnGroupDrop1" type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Colunas
                </button>
                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <form class="px-4 py-3">
                        <div v-for="(coluna,key) in column" class="form-group" :key="key">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" value="" v-model="showColumn[coluna[1]]">
                                <label class="form-check-label">{{coluna[0]}}</label>
                            </div>

                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>

    <div class="table table-responsive-lg">
        <div style="max-width: 1920px; overflow-x: auto;">
            <table class="table-striped table-bordered table-hover text-center table-filter" style="width: 100%;">
                <thead>
                    <tr>
                        <th class="form-check" v-if="actions.indexOf('select') > -1">
                            <label class="form-check-label">&nbsp;</label>
                            <input class="form-check-input" type="checkbox" @change="markAll($event)">
                        </th>

                        <th v-for="(coluna, index) in column" :key="index" v-show="showColumn[coluna[1]]">
                            <span>{{coluna[0]}}</span> <span :class="classSort(coluna[1])" @click="sorter(coluna[1])">&nbsp;</span>
                            <input v-if="showFilter" type="text" v-model="search[coluna[1]]" @keyup="filtrar(coluna[1])">
                        </th>
                        <th v-if="actions.indexOf('exp') > -1">Exportar</th>
                        <th v-if="actions.indexOf('show') > -1">Ver</th>
                        <th v-if="actions.indexOf('edit') > -1">Editar</th>
                        <th v-if="actions.indexOf('delet') > -1">Deletar</th>
                        <th v-if="actions.indexOf('image') > -1">Imagem</th>
                        <th v-if="actions.indexOf('recover') > -1">&nbsp; Recuperar</th>

                    </tr>

                </thead>

                <tbody>
                    <tr v-for="item in filteredData" :key="item.id">

                        <td v-if="actions.indexOf('select') > -1">
                            <div class="form-check" v-if="item.selectable">
                                <label class="form-check-label">
                                    <input type="checkbox" class="form-check-input" @click="changeSelect($event)" v-model="selectedItens" :value="item.id">

                                </label>
                            </div>
                        </td>

                        <td v-for="(coluna, index) in column" :key="index" v-show="showColumn[coluna[1]]">{{item[coluna[1]]}}</td>

                        <td v-if="actions.indexOf('exp') > -1">
                            <button class="btn btn-success" @click="exp(item.id)"><i class="far fa-file-excel"></i></button>
                        </td>

                        <td v-if="actions.indexOf('show') > -1">
                            <button class="btn btn-primary" @click="show(item.id)"><i class="fa fa-eye"></i></button>
                        </td>

                        <td v-if="actions.indexOf('edit') > -1">
                            <button class="btn btn-primary" @click="edit(item.id)"><i class="fa fa-edit"></i></button>
                        </td>

                        <td v-if="actions.indexOf('delet') > -1">

                            <button class="btn btn-primary" @click="delet(item.id)"><i class="fas fa-trash-alt"></i></button>

                        </td>

                        <td v-if="actions.indexOf('recover') > -1">

                            <button class="btn btn-primary" @click="recover(item.id)" v-if="item.recoverable"><i class="fas fa-redo-alt"></i></button>

                        </td>
                        <td v-if="actions.indexOf('image') > -1">
                            <a href="#" @click="openImg(item.imagem,item.nome)"> <img v-bind:src="item.imagem" width="100"> </a>

                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <div class="overflow-auto">
                <div>
                    <b-pagination v-model="actualPage" :total-rows="totalDisplay" :per-page="perPage" first-number></b-pagination>
                </div>
            </div> -->

        <div class="text-left" v-if="totalRegistros > 0">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRegistros"
                :per-page="perPage"
                first-number
                last-number
                align="fill"
            ></b-pagination>
            <!-- <ul class="pagination">

                <li class="page-item " :class="[ (actualPage === 1) ? 'disabled' : '',]">

                    <span class="page-link" aria-label="Previous" @click.prevent=" actualPage = (actualPage > 1)? --actualPage : 1">

                        <span aria-hidden="true">&laquo;</span>

                        <span class="sr-only">Previous</span>

                    </span>

                </li>

                <li v-for="n in totalPaginas" class="page-link" :class="[ (n === actualPage) ? 'active' : 'disabled']" :key="n">

                    <a href="#" @click.prevent="actualPage = n" v-if="n >= displayStart && n <= displayEnd">{{n}}</a>

                </li>

                <li class="page-item " :class="[ (actualPage === totalPaginas) ? 'disabled' : '',]">

                    <span class="page-link" aria-label="Next" @click.prevent=" actualPage = (actualPage < totalPaginas)? ++actualPage : totalPaginas">

                        <span aria-hidden="true">&raquo;</span>

                        <span class="sr-only">Previous</span>

                    </span>

                </li>

            </ul> -->

            <div class="text-center">

                Total Registros: {{totalRegistros}}

                <strong> | </strong>Max. por Página:

                <input style="width: 51px;" type="text" v-model="perPage" v-mask="'###'" min="0" @keyup="actualPage=1">

            </div>

        </div>

    </div>
</div>
</template>

<style scoped>
.table-filter>thead>tr>th {
    text-align: center;
}

.table-filter>thead>tr>th>.column-order:after {

    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
    font-size: 10px;
    color: #ccc;
    font-family: FontAwesome;
    content: "\f0dc";
    cursor: pointer;
}

.table-filter>thead>tr>th>.column-order-az:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: .3em;
    vertical-align: middle;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid transparent;
    border-left: .3em solid transparent;
    cursor: pointer;
}

.table-filter>thead>tr>th>.column-order-za:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: .3em;
    vertical-align: middle;
    content: "";
    border-bottom: .3em solid;
    border-right: .3em solid transparent;
    border-left: .3em solid transparent;
    cursor: pointer;
}

.column-list {
    font-size: 1.3em;
    padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/util/Table.vue